import SignUpStep from './SignUpStep';

export default SignUpStep;
